
export default class Utils {
    static FormatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') //return format 100,00 in short add comma separator
    }

    static DeepCopy(obj){
        return JSON.parse(JSON.stringify(obj));
    }

    static is_Numeric(num) {
        return !isNaN(parseFloat(num)) && isFinite(num);
      }
}